import { useState, useEffect, useRef } from 'react';
import { InputText } from 'ui/inputs';
import { FilterSegmentButton } from '../FilterSegmentButton';
import { FilterSegmentErrorButton } from '../FilterSegmentErrorButton';

const displayText = {
  placeholder: 'Enter a value',
};

type FilterStringValueInputProps = {
  onChange: (value: string) => void;
  value: string;
  id: string;
  hasError: boolean;
  isDisabled?: boolean;
  placeholder?: string;
};

export const FilterStringValueInput = ({
  onChange,
  value,
  id,
  hasError = false,
  isDisabled = false,
  placeholder = '',
}: FilterStringValueInputProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Effect: focus input when switching to 'editing' mode
  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);

  if (!isEditing && hasError) {
    return (
      <FilterSegmentErrorButton
        onClick={() => setIsEditing(true)}
        data-test="filter-string-value-input-error-button"
      >
        {placeholder || displayText.placeholder}
      </FilterSegmentErrorButton>
    );
  }

  if (!isEditing) {
    return (
      <FilterSegmentButton
        onClick={() => setIsEditing(true)}
        data-test="filter-string-value-input-edit-button"
        isDisabled={isDisabled}
      >
        {value || displayText.placeholder}
      </FilterSegmentButton>
    );
  }

  return (
    <InputText
      inputRef={inputRef}
      type="text"
      data-value={value}
      onChange={onChange}
      value={value}
      placeholder={placeholder || displayText.placeholder}
      id={`${id}-string-type-input`}
      onBlur={() => setIsEditing(false)}
    />
  );
};
